module.exports = __webpack_public_path__ + "img/shine.790d46e0.svg";